import React, { memo } from 'react'

function Logout({ user_device }) {
  const logoutHandler = () => {
    localStorage.clear()
    window.location.replace('/admin')
  }

  return (
    <div onClick={logoutHandler} className={'flex items-center cursor-pointer'}>
      <i
        className={`icon-logout text-2xl text-inactive-icon dark:text-slate-400 ${
          user_device === 'desktop' ? 'ml-2' : undefined
        }`}
      />
      {user_device === 'desktop' && (
        <div className={'p-2'}>
          <span className={`text-lg text-red-600 font-normal`}>خروج</span>
        </div>
      )}
    </div>
  )
}

export default memo(Logout)
